import React from 'react'
import './card.css'

const Card = ({ type, price, userNumber }) => {
  return (
    <div className="card__container" id='pricing'>
      <div className="card__top">
        <h2>{type}</h2>
        <p>up to {userNumber} users</p>
      </div>
      <div className="card__line"></div>
      <div className="card__bottom">
        <span>$<h2>{price}</h2></span>
        <p>per month</p>
        <a href="#pricing" className="rounded__btn-no_bg">Order</a>
      </div>
    </div>
  )
}

export default Card
